import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import { initErrorLogger } from './helpers/errorLogger';

// Initialize global error logging
initErrorLogger();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
